import React from 'react'
import AccountDetails from '../newCase/accountDetails'

const NewPlanEstimate = () => {
  return (
    <div>
      <AccountDetails heading="Create a New Case Plan for Estimate" />
    </div>
  )
}

export default NewPlanEstimate
